import React from 'react';
import { Segment, Dimmer, Loader } from 'semantic-ui-react';
import i18n from '../i18n';

const Loading = () => {
  return (
    <Segment style={{ height: 100 }}>
      <Dimmer active inverted>
        <Loader indeterminate>{i18n.t('ui.loading')}</Loader>
      </Dimmer>
    </Segment>
  );
};

export default Loading;
